module.exports = __webpack_public_path__ + "static/iela-transparent-ba7941b5f664b57e2c1dc260946a6354.svg";